import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-25a6a4f6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ai-generation-market-definition"
};
const _hoisted_2 = {
  key: 0,
  class: "loading-overlay"
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_5 = {
  class: "category-text-span"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "custom-disabled-class"
}, "Keyword (Coming Soon)", -1));
const _hoisted_7 = {
  class: "select-competitors-section"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ai_category_section_title = _resolveComponent("ai-category-section-title");
  const _component_b_form_radio = _resolveComponent("b-form-radio");
  const _component_app_choice_maker = _resolveComponent("app-choice-maker");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_flex_column = _resolveComponent("flex-column");
  const _component_competitors_modal_table = _resolveComponent("competitors-modal-table");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.loading_category ? (_openBlock(), _createElementBlock("div", _hoisted_2)) : _createCommentVNode("", true), _createVNode(_component_flex_column, {
    gap: 28,
    styles: {
      padding: '20px 24px'
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_flex_column, {
      gap: 16,
      styles: {
        height: 'auto'
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_ai_category_section_title, {
        title: "Search by Category or Keyword"
      }), _createVNode(_component_flex_row, {
        gap: 28,
        styles: {
          height: 'auto',
          justifyContent: 'flex-start'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_app_choice_maker, null, {
          selector: _withCtx(() => [_createVNode(_component_b_form_radio, {
            modelValue: $data.selected_strategy,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.selected_strategy = $event),
            value: "category",
            onChange: $options.onSelectStrategy
          }, null, 8, ["modelValue", "onChange"])]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createTextVNode(" Category "), _hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString($props.product.category_name), 1)])]),
          _: 1
        }), _createVNode(_component_app_choice_maker, null, {
          selector: _withCtx(() => [_createVNode(_component_b_form_radio, {
            modelValue: $data.selected_strategy,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.selected_strategy = $event),
            value: "keyword",
            onChange: $options.onSelectStrategy,
            disabled: $data.isDisabled
          }, null, 8, ["modelValue", "onChange", "disabled"])]),
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createElementVNode("div", _hoisted_7, [$data.competitors.length > 0 ? (_openBlock(), _createBlock(_component_competitors_modal_table, {
      key: 0,
      competitors: $data.competitors,
      onSelect: $options.onSelectCompetitors
    }, null, 8, ["competitors", "onSelect"])) : _createCommentVNode("", true)])]),
    _: 1
  })]);
}